// Titelskærmen: det første, man ser. Bagved spiller en ekspert-bot banen, så kortet lever, byerne
// tænder og stormene kommer forbi. Kortet er lille og lyst, så verden bagved kan ses.

import { h } from '../dom';
import { ICON } from '../icons';
import { modeButton, playModes } from './modes';

export interface TitleHandlers {
  /** Spil: første gang direkte til bane 1, ellers til banevalget. */
  play(): void;
  /** Sat, når en bane venter bag titlen. */
  resume?: { title: string; go(): void };
  /** Vælg bane og sværhed (forsiden). Skjult ved første besøg, så der kun er ét valg. */
  levels?(): void;
  atlas(): void;
  settings(): void;
  /** Spil med Volt, AI-makkeren (M3). */
  volt?(): void;
  /** Makkerspil (M4): også ved første besøg, så man kan finde en ven uden at have spillet først. */
  friend?(): void;
}

export function titleScreen(handlers: TitleHandlers, atlasCount: { have: number; total: number }): HTMLElement {
  const main = handlers.resume
    ? [
        h(
          'button',
          { type: 'button', class: 'btn primary big', autofocus: true, onclick: () => handlers.resume?.go() },
          h('span', { html: ICON.play }),
          `Fortsæt ${handlers.resume.title}`,
        ),
      ]
    : [h('button', { type: 'button', class: 'btn primary big', autofocus: true, onclick: () => handlers.play() }, h('span', { html: ICON.play }), 'Spil')];
  return h(
    'div',
    { class: 'card title-card' },
    h(
      'div',
      { class: 'title-block' },
      h('p', { class: 'eyebrow' }, 'Et netspil fra Energinet'),
      h('h1', { class: 'title logo' }, h('span', {}, 'FULD'), h('span', { class: 'logo-bolt', html: ICON.bolt }), h('span', {}, 'SPÆNDING')),
      h('p', { class: 'tagline' }, 'Byg nettet, der gør Danmark grønt.'),
    ),
    ...main,
    // Med en ven eller med Volt: lige under Spil, side om side.
    handlers.friend || handlers.volt
      ? playModes(
          [
            handlers.friend ? modeButton('friend', () => handlers.friend?.()) : null,
            handlers.volt ? modeButton('volt', () => handlers.volt?.()) : null,
          ],
          'duo',
        )
      : null,
    h(
      'div',
      { class: 'title-links' },
      handlers.levels
        ? h('button', { type: 'button', class: 'btn ghost', onclick: () => handlers.levels?.() }, h('span', { html: ICON.line }), handlers.resume ? 'Ny bane' : 'Baner')
        : null,
      h(
        'button',
        { type: 'button', class: 'btn ghost', onclick: () => handlers.atlas() },
        h('span', { html: ICON.book }),
        'Netatlas',
        h('small', { class: 'count' }, `${atlasCount.have}/${atlasCount.total}`),
      ),
      h('button', { type: 'button', class: 'btn ghost', onclick: () => handlers.settings() }, h('span', { html: ICON.gear }), 'Indstillinger'),
    ),
  );
}
